export const PRODUCT_TYPE_SIMPLE = 1;
export const PRODUCT_TYPE_COMPOSITE = 9;

//* fake list products for Skeleton
export const dataFakeForLoading = [
    {id: 1, products: [{id: 1}, {id: 2},{id: 3},{id: 4}, {id: 5}, {id: 6},{id: 7},{id: 8}]},
    {id: 2, products: [{id: 1}, {id: 2},{id: 3},{id: 4}, {id: 5}, {id: 6},{id: 7},{id: 8}]},
    {id: 3, products: [{id: 1}, {id: 2},{id: 3},{id: 4}, {id: 5}, {id: 6},{id: 7},{id: 8}]},
    {id: 4, products: [{id: 1}, {id: 2},{id: 3},{id: 4}, {id: 5}, {id: 6},{id: 7},{id: 8}]}
]